import {
	RegisterUserPayload,
	RegisterUserResponse,
	registerUser,
} from "@/api/register";
import { authService } from "@/services/auth";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useSignUpUser = (
	options?: MutationOptionsWithoutFn<RegisterUserResponse, RegisterUserPayload>,
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: registerUser,
		...options,
		onSuccess: (data) => {
			queryClient.setQueryData(["registered-user"], data);
			authService.setToken(data.auth_token);
		},
	});
};
